import {
    ExtraAsset,
    FinancialObligation,
    MortgageCalculationBodyParams,
    Property,
    Applicants
} from '@ap/ap-interface-apix-hypotheken-berekening';

export class MortgageCalculationBodyParamsBuilder {
    private applicants: Applicants;
    private financialObligation?: FinancialObligation;
    private property?: Property;
    private extraAsset?: ExtraAsset;

    withApplicants(applicants: Applicants): this {
        this.applicants = applicants;
        return this;
    }

    withFinancialObligation(financialObligation: FinancialObligation): this {
        this.financialObligation = financialObligation;
        return this;
    }

    withProperty(property: Property): this {
        this.property = property;
        return this;
    }

    withExtraAsset(extraAsset: ExtraAsset): this {
        this.extraAsset = extraAsset;
        return this;
    }

    build(): MortgageCalculationBodyParams {
        return {
            applicants: this.applicants,
            financial_obligation: this.financialObligation,
            property: this.property,
            extra_asset: this.extraAsset
        } as MortgageCalculationBodyParams;
    }
}
